import styled from 'styled-components'

export const CategoryColor = styled.div<{ hex: string }>`
  width: 42px;
  height: 42px;
  border-radius: 100%;
  background-color: ${({ hex }) => hex};
`
